import React from "react";
import CardGroup from "../../../components/cardGroup";
import HeaderSection from "../../../components/headerSection";
import HowWorks from "../../../components/howItWorks";
import Footer from "../home/footer";
import AssessmentsHighlights from "./assessmetnsHighlights";
import CareerPath from "./careerpath";
import KeyBenefits from "./keyBenefits";
function AiJobAssessment() {


  const obj = [
    {
      id: "01",
      icon: "/build-profile.png",
      heading: "Profile Setup",
      content:
        "Input key information about your current role, skills, and career goals.”",
    },
    {
      id: "02",
      icon: "/goal-achievement.png",
      heading: "AI Evaluation",
      content:
        "Our AI assesses your responses, comparing them with industry trends.",
    },

    {
      id: "04",
      icon: "/goal-achievement.png",
      heading: "Full Dashboard",
      content:
        "Access a detailed report and personalized career recommendations.",
    },
    {
      id: "05",
      icon: "/goal-achievement.png",
      heading: "Mentor Connect",
      content:
        "Optionally connect with a mentor for guidance on your career path.",
    },
  ];

  const cardDetails = [
    {
      title: "AI Literacy Quiz",
      description:
        "Assess your general AI preparedness by evaluating your skills, adaptability, and understanding of AI's impact on the workplace.",
      buttonText: "Take the Quiz",
      features: [
        "Ideal for: Professionals New to AI",
        "Time Required: 5 minutes",
        "Outcome: AI literacy score and tips",
      ],
    },
    {
      title: "AI Job Impact Assessment",
      description:
        "Understand how AI and automation could impact your current job role, identify tasks at risk, and get tailored recommendations for career growth.",
      buttonText: "Start Assessment",
      features: [
        "Ideal For: Role-specific insights seekers",
        "Time Required: 10-15 mins",
        "Outcome: Detailed report & plan",
      ],
    },
    {
      title: "Combined Assessment",
      description:
        "Maximize your career literacy with both assessments. Start with the AI Literacy Quiz, then dive into the Job Impact Assessment for a comprehensive analysis.",
      buttonText: "Get Started Now",
      features: [
        "Ideal For: Comprehensive AI insights",
        "Time Required: 20 mins",
        "Outcome: AI literacy report.",
      ],
    },
  ];

  return (
    <div>
      <HeaderSection
        title="AI Job Assessment"
        description="Discover Your AI Career Potential and Personalized Insights for a Future-Ready Path"
      />
      <KeyBenefits />
      <AssessmentsHighlights />
      <HowWorks obj={obj} title="How It Works" />
      <CardGroup
        cards={cardDetails}
        label="AI Job Impact Assessment Report Tiers"
      />
      <CareerPath
        label1="Ready to take control of your "
        label2="career path?"
        description="Begin your assessment now and embark on a journey toward resilience and growth in an ever-evolving job market."
        descriptionClass="w-[621px] text-center"
        buttonText="START YOUR ASSESSMENT"
      />
      <Footer />
    </div>
  );
}

export default AiJobAssessment;
